<template>
  <v-container fluid>
    <v-card>
      <v-card-text class="text-center">
        <v-row class="justify-center">
          <v-col cols="12" class="mx-auto">
            <h4>Get started with Sasa<span class="red--text">Pay</span> Developer Nomenclature</h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-text>
        <v-card-text>
          The Sasa<span class="red--text">Pay</span>  - A product of ViewTech Ltd authorized and regulated by Central Bank of Kenya
        </v-card-text>
        <v-card-text>
          The Merchant Code unique number assigned to an organization/merchant registered with ViewTech, through which payment is received (can be Paybill or Till number)
        </v-card-text>
      </v-card-text>
    </v-card>
    <v-divider/>
    <v-row>
      <v-col cols="12" md="4" class="mx-auto">
        <v-card>
          <v-card-title>Response Codes</v-card-title>
          <v-card-text>
            <v-data-table :hide-default-footer="true" :items="codes" :headers="headers"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Nomenclature",
  data: ()=>({
    headers:[
      {
        text: 'Code',
        align: '',
        sortable: true,
        value: 'code'
      },
      {
        text: 'Description',
        align: '',
        sortable: true,
        value: 'description'
      },
    ],
    codes:[
      {
        code:"0",
        description:"Success"
      },
      {
        code:"401-1",
        description:"Missing Authentication credentials "
      },
      {
        code:"400-1",
        description:"Invalid Parameter"
      },
      {
        code:"409-1",
        description:"Beneficiary Already Exists"
      },
      {
        code:"409-2",
        description:"Transaction Reference is Already Used"
      },
      {
        code:"404-2",
        description:"Not Found"
      },
      {
        code:"422-1",
        description:"Insufficient Balance"
      },
    ]
  }),
  mounted(){
  }
}
</script>

<style scoped>

</style>